"use strict";

function _extends2() { _extends2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends2.apply(this, arguments); }

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _reactBigCalendarApm = _interopRequireDefault(require("@appfolio/react-big-calendar-apm"));

var _fechaLocalizer = _interopRequireDefault(require("./fechaLocalizer.js"));

var _CustomAgenda = _interopRequireDefault(require("./CustomAgenda"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
} // TODO temp - shouldn't need this but workaround


if (typeof global !== 'undefined') {
  _extends2(global, {
    _JSXStyle: _style["default"]
  });
}
/* eslint-disable react/jsx-no-bind */
// TODO below may need to be extracted to allow configuration:


_reactBigCalendarApm["default"].setLocalizer(_fechaLocalizer["default"]);

var customViews = {
  'agenda-detailed': ['agenda', _CustomAgenda["default"]]
};

var timeRangeFormat = function timeRangeFormat(_ref, culture, local) {
  var start = _ref.start,
      end = _ref.end;
  return "".concat(local.format(start, 'h:mmA', culture), " \u2014 ").concat(local.format(end, 'h:mmA', culture));
};

var FORMATS = {
  agendaTimeRangeFormat: timeRangeFormat,
  dateFormat: 'D',
  dayFormat: 'ddd M/D',
  dayHeaderFormat: 'MMM D, YYYY',
  dayRangeHeaderFormat: function dayRangeHeaderFormat(_ref2, culture, local) {
    var start = _ref2.start,
        end = _ref2.end;
    var startFormat = start.getYear() === end.getYear() ? 'MMM D' : 'MMM D, YYYY';
    var endFormat = start.getMonth() === end.getMonth() ? 'D, YYYY' : 'MMM D, YYYY';
    return "".concat(local.format(start, startFormat, culture), " - ").concat(local.format(end, endFormat, culture));
  },
  eventTimeRangeFormat: function eventTimeRangeFormat() {
    return '';
  },
  monthHeaderFormat: 'MMMM YYYY',
  selectRangeFormat: timeRangeFormat,
  timeGutterFormat: 'h:mm A',
  agendaHeaderFormat: function agendaHeaderFormat(_ref3, culture, local) {
    var start = _ref3.start;
    return "".concat(local.format(start, 'MMM, YYYY', culture));
  },
  agendaDateFormat: 'MMM D, YYYY'
};

var Calendar = /*#__PURE__*/function (_React$Component) {
  _inherits(Calendar, _React$Component);

  var _super = _createSuper(Calendar);

  function Calendar(props) {
    var _this;

    _classCallCheck(this, Calendar);

    _this = _super.call(this, props);

    _this.eventPropGetter = function (event, start, end, isSelected, view) {
      var eventPropGetter = _this.props.eventPropGetter;
      var propsToReturn = {
        className: "rgc-event rgc-event--".concat(event.type, " alert alert-info")
      };

      if (['month', 'agenda'].includes(view) || event.allDay) {
        propsToReturn.className += ' rgc-event--no-overflow';
      }

      if (isSelected) {
        propsToReturn.className += ' rgc-event--selected';
      }

      if (eventPropGetter) {
        var _eventPropGetter = eventPropGetter(event, start, end, isSelected, view),
            className = _eventPropGetter.className,
            style = _eventPropGetter.style;

        propsToReturn.className += " ".concat(className);
        propsToReturn.style = style;
      }

      return propsToReturn;
    };

    _this.onView = function (view, date) {
      var onView = _this.props.onView;

      if (onView && typeof onView === 'function') {
        onView(view, date);
      }

      _this.changeViewState(view);
    };

    _this.onNavigate = function (date, view) {
      var onNavigate = _this.props.onNavigate;

      if (onNavigate && typeof onNavigate === 'function') {
        onNavigate(date, view);
      }
    };

    _this.onDayMore = function (date, view, callBack) {
      callBack(date, view);

      _this.changeViewState(_this.props.drilldownView);
    };

    _this.state = {
      defaultViewState: 'month'
    };
    return _this;
  }

  _createClass(Calendar, [{
    key: "formatViews",
    value: function formatViews(views) {
      var customView;
      var i;
      var obj = {};
      var view;

      if (views instanceof Array === false) {
        return views;
      }

      for (i = 0; i < views.length; i += 1) {
        view = views[i];

        if (Object.prototype.hasOwnProperty.call(customViews, view)) {
          customView = customViews[view];
          obj[customView[0]] = customView[1];
        } else {
          obj[view] = true;
        }
      }

      return obj;
    }
  }, {
    key: "changeViewState",
    value: function changeViewState(view) {
      if (view) {
        this.setState({
          defaultViewState: view
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.changeViewState(this.props.selectedView);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          events = _this$props.events,
          formats = _this$props.formats,
          popup = _this$props.popup,
          views = _this$props.views,
          onView = _this$props.onView,
          onNavigate = _this$props.onNavigate,
          _onDayMore = _this$props.onDayMore,
          props = _objectWithoutProperties(_this$props, ["events", "formats", "popup", "views", "onView", "onNavigate", "onDayMore"]);

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "jsx-207969338" + " " + "h-100 overflow-auto"
      }, /*#__PURE__*/_react["default"].createElement(_reactBigCalendarApm["default"], _extends({
        events: events,
        formats: formats,
        startAccessor: "startAt",
        endAccessor: "endAt",
        popup: popup,
        views: this.formatViews(views),
        onNavigate: this.onNavigate,
        onView: this.onView,
        view: this.state.defaultViewState,
        eventPropGetter: this.eventPropGetter,
        changeView: this.changeViewState.bind(this),
        onDayMore: function onDayMore(view, date) {
          return _this2.onDayMore(view, date, _onDayMore);
        }
      }, props)), /*#__PURE__*/_react["default"].createElement(_style["default"], {
        id: "207969338"
      }, ".rbc-btn{color:inherit;font:inherit;margin:0;}button.rbc-btn{overflow:visible;text-transform:none;-webkit-appearance:button;cursor:pointer;}button[disabled].rbc-btn{cursor:not-allowed;}button.rbc-input::-moz-focus-inner{border:0;padding:0;}.rbc-calendar{box-sizing:border-box;height:100%;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;-webkit-align-items:stretch;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;}.rbc-calendar *,.rbc-calendar *:before,.rbc-calendar *:after{box-sizing:inherit;}.rbc-abs-full,.rbc-row-bg{overflow:hidden;position:absolute;top:0;left:0;right:0;bottom:0;}.rbc-ellipsis,.rbc-event-label,.rbc-row-segment .rbc-event-content,.rbc-show-more{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}.rbc-rtl{direction:rtl;}.rbc-off-range{color:#b3b3b3;}.rbc-header{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding:0 3px;text-align:center;vertical-align:middle;font-weight:bold;font-size:90%;min-height:0;}.rbc-header>a,.rbc-header>a:active,.rbc-header>a:visited{color:inherit;-webkit-text-decoration:none;text-decoration:none;}.rbc-row-content{position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:4;}.rbc-today{background-color:#eaf6ff;}.rbc-toolbar{display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:10px;font-size:16px;-ms-flex-pack:justify;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;}@media (max-width:600px){.rbc-toolbar{-ms-flex-wrap:wrap;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;}.rbc-toolbar .rbc-btn-group:last-child{margin-top:0.5em;width:100%;}}.rbc-toolbar .rbc-toolbar-label{font-weight:bold;padding:0 10px;text-align:center;}.rbc-toolbar button{color:#373a3c;display:inline-block;margin:0;text-align:center;vertical-align:middle;background:none;background-image:none;border:1px solid #ccc;padding:.375rem 1rem;border-radius:4px;line-height:normal;white-space:nowrap;}.rbc-toolbar button:active,.rbc-toolbar button.rbc-active{background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,0.125);background-color:#e6e6e6;border-color:#adadad;}.rbc-toolbar button:active:hover,.rbc-toolbar button.rbc-active:hover,.rbc-toolbar button:active:focus,.rbc-toolbar button.rbc-active:focus{color:#373a3c;background-color:#d4d4d4;border-color:#8c8c8c;}.rbc-toolbar button:focus{color:#373a3c;background-color:#e6e6e6;border-color:#adadad;}.rbc-toolbar button:hover{color:#373a3c;background-color:#e6e6e6;border-color:#adadad;}.rbc-btn-group{display:inline-block;white-space:nowrap;}.rbc-btn-group>button:first-child:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0;}.rbc-btn-group>button:last-child:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0;}.rbc-rtl .rbc-btn-group>button:first-child:not(:last-child){border-radius:4px;border-top-left-radius:0;border-bottom-left-radius:0;}.rbc-rtl .rbc-btn-group>button:last-child:not(:first-child){border-radius:4px;border-top-right-radius:0;border-bottom-right-radius:0;}.rbc-btn-group>button:not(:first-child):not(:last-child){border-radius:0;}.rbc-btn-group button+button{margin-left:-1px;}.rbc-rtl .rbc-btn-group button+button{margin-left:0;margin-right:-1px;}.rbc-btn-group+.rbc-btn-group,.rbc-btn-group+button{margin-left:10px;}.rbc-event{cursor:pointer;padding:2px 5px;}.rbc-event-label{font-size:80%;}.rbc-event-overlaps{box-shadow:-1px 1px 5px 0px rgba(51,51,51,0.5);}.rbc-event-continues-prior{border-top-left-radius:0;border-bottom-left-radius:0;}.rbc-event-continues-after{border-top-right-radius:0;border-bottom-right-radius:0;}.rbc-event-continues-earlier{border-top-left-radius:0;border-top-right-radius:0;}.rbc-event-continues-later{border-bottom-left-radius:0;border-bottom-right-radius:0;}.rbc-row{display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:row;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;}.rbc-row-segment{padding:0 1px 1px 1px;}.rbc-selected-cell{background-color:rgba(0,0,0,0.1);}.rbc-show-more{background-color:rgba(255,255,255,0.3);z-index:4;font-weight:bold;font-size:85%;height:auto;line-height:normal;white-space:nowrap;}.rbc-month-view{position:relative;border:1px solid #DDD;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex:1 0 0px;-webkit-flex:1 0 0;-ms-flex:1 0 0;flex:1 0 0;width:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;height:100%;}.rbc-month-view .rbc-header{border-bottom:1px solid #DDD;}.rbc-month-view .rbc-header+.rbc-header{border-left:1px solid #DDD;}.rbc-rtl .rbc-month-view .rbc-header+.rbc-header{border-left-width:0;border-right:1px solid #DDD;}.rbc-month-header{display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:row;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;}.rbc-month-row{display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;position:relative;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex:1 0 0px;-webkit-flex:1 0 0;-ms-flex:1 0 0;flex:1 0 0;overflow:hidden;height:100%;}.rbc-month-row+.rbc-month-row{border-top:1px solid #DDD;}.rbc-date-cell{padding-right:5px;text-align:right;}.rbc-date-cell.rbc-now{font-weight:bold;}.rbc-date-cell>a,.rbc-date-cell>a:active,.rbc-date-cell>a:visited{color:inherit;-webkit-text-decoration:none;text-decoration:none;}.rbc-row-bg{display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:row;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex:1 0 0px;-webkit-flex:1 0 0;-ms-flex:1 0 0;flex:1 0 0;overflow:hidden;}.rbc-day-bg+.rbc-day-bg{border-left:1px solid #DDD;}.rbc-rtl .rbc-day-bg+.rbc-day-bg{border-left-width:0;border-right:1px solid #DDD;}.rbc-overlay{position:absolute;z-index:5;border:1px solid #e5e5e5;background-color:#fff;box-shadow:0 5px 15px rgba(0,0,0,0.25);padding:10px;}.rbc-overlay>*+*{margin-top:1px;}.rbc-overlay-header{border-bottom:1px solid #e5e5e5;margin:-10px -10px 5px -10px;padding:2px 10px;}.rbc-agenda-view{display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex:1 0 0px;-webkit-flex:1 0 0;-ms-flex:1 0 0;flex:1 0 0;overflow:auto;}.rbc-agenda-view table{width:100%;border:1px solid #DDD;}.rbc-agenda-view table tbody>tr>td{padding:5px 10px;vertical-align:top;}.rbc-agenda-view table .rbc-agenda-time-cell{padding-left:15px;padding-right:15px;text-transform:lowercase;}.rbc-agenda-view table tbody>tr>td+td{border-left:1px solid #DDD;}.rbc-rtl .rbc-agenda-view table tbody>tr>td+td{border-left-width:0;border-right:1px solid #DDD;}.rbc-agenda-view table tbody>tr+tr{border-top:1px solid #DDD;}.rbc-agenda-view table thead>tr>th{padding:3px 5px;text-align:left;border-bottom:1px solid #DDD;}.rbc-rtl .rbc-agenda-view table thead>tr>th{text-align:right;}.rbc-agenda-time-cell{text-transform:lowercase;}.rbc-agenda-time-cell .rbc-continues-after:after{content:' \xBB';}.rbc-agenda-time-cell .rbc-continues-prior:before{content:'\xAB ';}.rbc-agenda-date-cell,.rbc-agenda-time-cell{white-space:nowrap;}.rbc-agenda-event-cell{width:100%;}.rbc-empty-agenda-content{height:100vh;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;}.rbc-empty-agenda-message{text-align:center;color:gray;}.rbc-time-column{display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;min-height:100%;}.rbc-time-column .rbc-timeslot-group{-ms-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;}.rbc-timeslot-group{border-bottom:1px solid #DDD;min-height:40px;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;-webkit-flex-flow:column nowrap;-ms-flex-flow:column nowrap;flex-flow:column nowrap;}.rbc-time-gutter,.rbc-header-gutter{-ms-flex:none;-webkit-flex:none;-ms-flex:none;flex:none;}.rbc-label{padding:0 5px;}.rbc-day-slot{position:relative;}.rbc-day-slot .rbc-event{border:1px solid #265985;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;max-height:100%;-ms-flex-flow:column wrap;-webkit-flex-flow:column wrap;-ms-flex-flow:column wrap;flex-flow:column wrap;-ms-flex-align:start;-webkit-align-items:flex-start;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;overflow:hidden;}.rbc-day-slot .rbc-event-label{-ms-flex:none;-webkit-flex:none;-ms-flex:none;flex:none;padding-right:5px;width:auto;}.rbc-day-slot .rbc-event-content{width:100%;-ms-flex:1 1 0px;-webkit-flex:1 1 0;-ms-flex:1 1 0;flex:1 1 0;word-wrap:break-word;line-height:1;height:100%;min-height:1em;}.rbc-day-slot .rbc-time-slot{border-top:1px solid #f7f7f7;}.rbc-time-slot{-ms-flex:1 0 0px;-webkit-flex:1 0 0;-ms-flex:1 0 0;flex:1 0 0;}.rbc-time-slot.rbc-now{font-weight:bold;}.rbc-day-header{text-align:center;}.rbc-day-slot .rbc-event{position:absolute;z-index:2;}.rbc-slot-selection{z-index:10;position:absolute;cursor:default;background-color:rgba(0,0,0,0.5);color:white;font-size:75%;padding:3px;}.rbc-time-view{display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;width:100%;border:1px solid #DDD;min-height:0;}.rbc-time-view .rbc-time-gutter{white-space:nowrap;}.rbc-time-view .rbc-allday-cell{width:100%;position:relative;}.rbc-time-view .rbc-allday-events{position:relative;z-index:4;}.rbc-time-view .rbc-row{min-height:20px;}.rbc-time-header{display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-ms-flex:0 0 auto;-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}.rbc-time-header.rbc-overflowing{border-right:1px solid #DDD;}.rbc-rtl .rbc-time-header.rbc-overflowing{border-right-width:0;border-left:1px solid #DDD;}.rbc-time-header>.rbc-row>*+*{border-left:1px solid #DDD;}.rbc-rtl .rbc-time-header>.rbc-row>*+*{border-left-width:0;border-right:1px solid #DDD;}.rbc-time-header>.rbc-row:first-child{border-bottom:1px solid #DDD;}.rbc-time-header .rbc-gutter-cell{-ms-flex:none;-webkit-flex:none;-ms-flex:none;flex:none;}.rbc-time-header>.rbc-gutter-cell+*{width:100%;}.rbc-time-content{display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-ms-flex:1 0 0%;-webkit-flex:1 0 0%;-ms-flex:1 0 0%;flex:1 0 0%;-ms-flex-align:start;-webkit-align-items:flex-start;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;width:100%;border-top:2px solid #DDD;overflow-y:auto;position:relative;}.rbc-time-content>.rbc-time-gutter{-ms-flex:none;-webkit-flex:none;-ms-flex:none;flex:none;}.rbc-time-content>*+*>*{border-left:1px solid #DDD;}.rbc-rtl .rbc-time-content>*+*>*{border-left-width:0;border-right:1px solid #DDD;}.rbc-time-content>.rbc-day-slot{width:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}.rbc-current-time-indicator{position:absolute;z-index:1;left:0;height:1px;background-color:#74ad31;pointer-events:none;}.rbc-current-time-indicator::before{display:block;position:absolute;left:-3px;top:-3px;content:' ';background-color:#74ad31;border-radius:50%;width:8px;height:8px;}.rbc-rtl .rbc-current-time-indicator::before{left:0;right:-3px;}.rbc-calendar{min-height:650px;}.rbc-event{font-size:85%;margin:0 1px;padding:2px;}.rgc-event:not(.rgc-event--no-overflow){display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}.rbc-now a{font-weight:normal;}.rbc-today{background-color:#fcf8e3;}.rbc-toolbar-label{font-weight:bold;}"));
    }
  }]);

  return Calendar;
}(_react["default"].Component);

exports["default"] = Calendar;
Calendar.propTypes = {
  events: _propTypes["default"].array,
  formats: _propTypes["default"].object,
  popup: _propTypes["default"].bool,
  views: _propTypes["default"].array || _propTypes["default"].object,
  selectedView: _propTypes["default"].string,
  defaultDate: _propTypes["default"].instanceOf(Date)
};
Calendar.defaultProps = {
  events: [],
  formats: FORMATS,
  popup: false,
  views: ['month', 'week', 'day', 'agenda-detailed'],
  selectedView: 'month'
};